module.exports = __webpack_public_path__ + "img/search.0a96110a.svg";